module.exports = __webpack_public_path__ + "static/img/meun-icon.7f1e63a6.svg";